import type { VueformFieldType } from '../types/form-builder-types'

export const FIELD_TYPE_ICONS: Record<VueformFieldType, string> = {
  text: 'bi-input-cursor-text',
  textarea: 'bi-textarea-t',
  editor: 'bi-pencil-square',
  select: 'bi-menu-button-wide',
  multiselect: 'bi-menu-button-wide-fill',
  tags: 'bi-tags',
  radio: 'bi-ui-radios',
  checkbox: 'bi-check-square',
  toggle: 'bi-toggle-on',
  date: 'bi-calendar-event',
  dates: 'bi-calendar3-range',
  file: 'bi-file-earmark-arrow-up',
  multifile: 'bi-files',
  image: 'bi-image',
  slider: 'bi-sliders',
  hidden: 'bi-eye-slash',
  static: 'bi-file-text',
}

export const FIELD_TYPE_LABELS: Record<VueformFieldType, string> = {
  text: 'Text Input',
  textarea: 'Multi-line Text',
  editor: 'Rich Text Editor',
  select: 'Dropdown',
  multiselect: 'Multi-select Dropdown',
  tags: 'Tags Input',
  radio: 'Radio Buttons',
  checkbox: 'Checkbox',
  toggle: 'Toggle Switch',
  date: 'Date Picker',
  dates: 'Multiple Dates',
  file: 'File Upload',
  multifile: 'Multiple Files',
  image: 'Image Upload',
  slider: 'Slider',
  hidden: 'Hidden Field',
  static: 'Static Text',
}

export const FIELD_TYPE_DESCRIPTIONS: Record<VueformFieldType, string> = {
  text: 'Single line text input for short responses',
  textarea: 'Multi-line text area for longer text',
  editor: 'WYSIWYG rich text editor with formatting',
  select: 'Dropdown menu with single selection',
  multiselect: 'Dropdown menu with multiple selections',
  tags: 'Tag input for comma-separated values',
  radio: 'Radio button group for single selection',
  checkbox: 'Single checkbox or checkbox group',
  toggle: 'On/off toggle switch',
  date: 'Date picker for single date selection',
  dates: 'Date picker for multiple dates',
  file: 'File upload for single file',
  multifile: 'File upload for multiple files',
  image: 'Image upload with preview',
  slider: 'Range slider for numeric values',
  hidden: 'Hidden field (not visible to user)',
  static: 'Static text or HTML content',
}

// Field types grouped by category
export const FIELD_TYPE_CATEGORIES = {
  'Text Inputs': ['text', 'textarea', 'editor'] as VueformFieldType[],
  'Selection': ['select', 'multiselect', 'tags', 'radio', 'checkbox', 'toggle'] as VueformFieldType[],
  'Date & Time': ['date', 'dates'] as VueformFieldType[],
  'File Upload': ['file', 'multifile', 'image'] as VueformFieldType[],
  'Other': ['slider', 'hidden', 'static'] as VueformFieldType[],
}
